import service from "@/api/service";
import { SearchRequest } from "@/api/regist-stripe-shop/request";
import { SearchResponse } from "@/api/regist-stripe-shop/response";

/**
 * Stripe加盟店登録情報一覧・検索APIをコールします。
 *
 * @param searchRequest 店舗検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post(
    "/search-regist-stripe-shop",
    searchRequest
  );
  return response.data as SearchResponse;
}
